import { $getQueryParams } from '@/utils';
import httpService from '@Utils/httpService';

const baseUrl = 'api/tasks';

export default {
  get(taskId,params) {
    const qParams = $getQueryParams(params);

    return httpService.get({
      url: baseUrl + `/${taskId}/comments?` + qParams.toString(),
    });
  },
 
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/comments/${data.id}`,
      data,
    });
  },
  
  add( data) {
    return httpService.post({
      url: baseUrl+`/${data.taskId}/Comments`,
      data,
    });
  },
 
  

  del(id) {
    return httpService.delete({
      url: `${baseUrl}/Comments/${id}`,
    });
  },
};
